import { ExternalLink } from "lucide-react";
import Reveal from "./Reveal";
import Stars from "./Stars";

const GOOGLE_REVIEWS_URL =
  "https://www.google.co.uk/maps/place/City+Civils+Construction+%26+Landscaping/@55.8177154,-3.3395038,11.1z/data=!4m18!1m9!3m8!1s0x49b7e212946c3c67:0x46b14c33913d95b7!2sCity+Civils+Construction+%26+Landscaping!8m2!3d54.2990468!4d-2.9395136!9m1!1b1!16s%2Fg%2F11x0r94f8s!3m7!1s0x49b7e212946c3c67:0x46b14c33913d95b7!8m2!3d54.2990468!4d-2.9395136!9m1!1b1!16s%2Fg%2F11x0r94f8s";

function GoogleG({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}

export default function GoogleReviewsPanel({ variant = "full", rating = 5.0, count = 9 }) {
  return (
    <Reveal className={variant === "compact" ? "" : "max-w-4xl mx-auto"}>
      <a
        href={GOOGLE_REVIEWS_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="google-reviews-panel"
        className="group block relative overflow-hidden bg-[#0B0B0B] border border-[#181818] hover:border-[#F28C00]/60 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_25px_60px_-20px_rgba(242,140,0,0.35)]"
      >
        {/* Top accent line */}
        <div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-transparent via-[#F28C00] to-transparent opacity-70" />

        <div className="p-8 md:p-10 grid md:grid-cols-[auto_1fr_auto] gap-8 md:gap-10 items-center">
          {/* Left: Big rating */}
          <div className="flex items-center gap-5">
            <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-white shrink-0">
              <GoogleG className="w-9 h-9 md:w-11 md:h-11" />
            </div>
            <div>
              <div className="font-display font-black text-white text-4xl md:text-5xl leading-none">
                {rating.toFixed(1)}
              </div>
              <Stars className="mt-2" />
            </div>
          </div>

          {/* Middle: Text */}
          <div className="min-w-0">
            <p className="cc-eyebrow mb-3">Google Reviews</p>
            <h3 className="font-display font-bold uppercase text-white text-xl md:text-2xl leading-tight">
              Rated {rating.toFixed(1)} out of 5<br className="hidden md:block" />
              <span className="text-[#F28C00]">from {count} verified reviews</span>
            </h3>
          </div>

          {/* Right: CTA */}
          <div className="flex md:justify-end">
            <span className="cc-btn-primary group-hover:translate-x-1 transition-transform">
              Read All Reviews <ExternalLink className="w-4 h-4" />
            </span>
          </div>
        </div>
      </a>
    </Reveal>
  );
}
